import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { featureFlags } from "../lib/config/featureFlags";
import { ROUTES } from "./constants";
import { protectedRoute } from "./helpers";

const HowToPage = lazy(() => import("../einstein/components/howto/HowToPage"));

export const howToRoutes: RouteObject[] = featureFlags.isHowToEnabled
	? [
			{
				path: ROUTES.HOW_TO,
				element: protectedRoute(<HowToPage />),
			},
		]
	: [];
